export default __webpack_public_path__ + "static/media/Annual-Filing-Template.c5f5d311.xlsx";